export default class Blog {
  constructor() {
    this.currentPage = 1;
    this.totalPages = 0;

    this.$header = document.querySelector(".js-header");
    this.$loadMoreContainer = document.querySelector(".js-load-more-container");
    this.$loadMoreButton = document.querySelector(".js-load-more-articles");

    if (this.$loadMoreButton) {
      this.$loadMoreButton.addEventListener(
        "click",
        this.loadMoreArticles.bind(this),
      );
    }

    this.$articles = document.querySelectorAll(".js-blog-article-card");
    if (this.$articles.length) {
      this.totalPages = parseInt(
        this.$articles[this.$articles.length - 1].dataset.page,
      );
    }

    this.$articles.forEach((article) => {
      if (parseInt(article.dataset.page) > this.currentPage) {
        article.style.display = "none";
      }
    });

    if (
      this.$loadMoreContainer &&
      (!this.totalPages || this.totalPages === 1)
    ) {
      this.$loadMoreContainer.style.display = "none";
    }

    if (document.body.classList.contains("blog")) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 20) {
          this.$header.classList.remove("bg-transparent");
          this.$header.classList.add("bg-black");
        } else {
          this.$header.classList.remove("bg-black");
          this.$header.classList.add("bg-transparent");
        }
      });
    }
  }

  loadMoreArticles() {
    this.currentPage += 1;

    this.$articles.forEach((article) => {
      if (parseInt(article.dataset.page) <= this.currentPage) {
        article.style.display = "";
      }
    });

    if (this.$loadMoreContainer && this.currentPage === this.totalPages) {
      this.$loadMoreContainer.style.display = "none";
    }
  }
}
